import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button
} from "@chakra-ui/react";
import ErrorMessage from "./ErrorMessage";

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  onConfirm: () => void;
  isSubmitting?: boolean;
  submittingError: string;
}

const EditModal: React.FC<EditModalProps> = ({ isOpen, onClose, title, content, isSubmitting, onConfirm, submittingError }) => {
    return (
        <Modal 
            isOpen={isOpen} 
            onClose={onClose}
            isCentered
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edytuj {title.toLowerCase()}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {content}
                    <ErrorMessage text={submittingError} />
                </ModalBody>
                
                <ModalFooter>
                <Button 
                    colorScheme="blue" 
                    mr={3} 
                    onClick={onClose}
                >
                    Close
                </Button>
                <Button 
                    isLoading={isSubmitting}
                    colorScheme="brand" 
                    onClick={onConfirm}
                >
                    Confirm
                </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditModal;